<template>
  <el-row v-if="!editMode">
    <el-col :xs="24" :sm="24" :lg="24" v-if="canViewSignOff" class="mt-20">
      <el-main class="signoff-main">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>簽核紀錄</span>
          </div>
          <div>
            <el-table :data="historyTableData" empty-text="尚無簽核紀錄" stripe :default-expand-all="true">
              <el-table-column label="簽核時間" prop="updatedAt" width="140">
                <template slot-scope="scope">
                  <p>{{ scope.row.updatedAt | fmtDateTime }}</p>
                </template>
              </el-table-column>
              <el-table-column label="簽核人員" width="100">
                <template slot-scope="scope">
                  <p>{{ scope.row.signerObj.username }}</p>
                </template>
              </el-table-column>
              <el-table-column label="結果" prop="signResult" width="60">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.signResult === 'N' || scope.row.signResult === 'invalid'" type="danger">{{ scope.row.signResult | signResult }}</el-tag>
                  <el-tag v-else>{{ scope.row.signResult | signResult }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="" type="expand">
                <template slot-scope="scope">
                  <p style="padding-left: 10px;">簽核備註 : {{ scope.row.notes }}</p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-main>
    </el-col>
  </el-row>
</template>

<script>

export default {
  name: "SignOffHistory",
  props: ['editMode', 'canViewSignOff'],
  data() {
    return {
      mytodoId:'',
      historyTableData:[]
    }
  },
  methods: {
    loadJobSignHistory() {
      this.request.get("/job/signoff/history/" + this.mytodoId).then(res => {
        if (res.code === '200') {
          this.historyTableData = res.data
        } else {
          this.showResult('error', '簽核紀錄撈取失敗')
        }
      })
    },
  },
  
  mounted() {
    this.mytodoId = this.$route.params.mytodoId
    this.loadJobSignHistory()
    
  }
}
</script>

<style scoped>
.el-main {
  padding: 0;
  margin-bottom: 20px;
}
.signoff-main >>> .el-card__body {
  padding: 0 8px;
}

</style>
